import type { ProductCreate } from "@/types/products/api-types/product-types";
import type { addProductSchema } from "@/zod-schemas/products/add-product-schema";
import type { z } from "zod";

type ProductFormValidated = z.infer<typeof addProductSchema>;

export const toProductRequest = (
  value: ProductFormValidated,
): ProductCreate => ({
  name: value.name,
  category_id: value.category.value,
  brand_id: value.brand.value,
  size_value: value.size_value,
  size_unit: value.size_unit,
  cost_price: value.cost_price,
  retail_price: value.retail_price,
});
